const state = {
    batchProductions: [],
    loading: false
};

export default state;